import { z } from 'zod';
/**
 * ISO 3166-1 alpha-2 country codes.
 *
 * This shared enum should be used anywhere we need to represent a country code
 * across the platform to ensure consistent validation and avoid duplicate lists.
 */
export var CountryCode;
(function (CountryCode) {
    CountryCode["AF"] = "AF";
    CountryCode["AX"] = "AX";
    CountryCode["AL"] = "AL";
    CountryCode["DZ"] = "DZ";
    CountryCode["AS"] = "AS";
    CountryCode["AD"] = "AD";
    CountryCode["AO"] = "AO";
    CountryCode["AI"] = "AI";
    CountryCode["AQ"] = "AQ";
    CountryCode["AG"] = "AG";
    CountryCode["AR"] = "AR";
    CountryCode["AM"] = "AM";
    CountryCode["AW"] = "AW";
    CountryCode["AU"] = "AU";
    CountryCode["AT"] = "AT";
    CountryCode["AZ"] = "AZ";
    CountryCode["BS"] = "BS";
    CountryCode["BH"] = "BH";
    CountryCode["BD"] = "BD";
    CountryCode["BB"] = "BB";
    CountryCode["BY"] = "BY";
    CountryCode["BE"] = "BE";
    CountryCode["BZ"] = "BZ";
    CountryCode["BJ"] = "BJ";
    CountryCode["BM"] = "BM";
    CountryCode["BT"] = "BT";
    CountryCode["BO"] = "BO";
    CountryCode["BQ"] = "BQ";
    CountryCode["BA"] = "BA";
    CountryCode["BW"] = "BW";
    CountryCode["BV"] = "BV";
    CountryCode["BR"] = "BR";
    CountryCode["IO"] = "IO";
    CountryCode["BN"] = "BN";
    CountryCode["BG"] = "BG";
    CountryCode["BF"] = "BF";
    CountryCode["BI"] = "BI";
    CountryCode["KH"] = "KH";
    CountryCode["CM"] = "CM";
    CountryCode["CA"] = "CA";
    CountryCode["CV"] = "CV";
    CountryCode["KY"] = "KY";
    CountryCode["CF"] = "CF";
    CountryCode["TD"] = "TD";
    CountryCode["CL"] = "CL";
    CountryCode["CN"] = "CN";
    CountryCode["CX"] = "CX";
    CountryCode["CC"] = "CC";
    CountryCode["CO"] = "CO";
    CountryCode["KM"] = "KM";
    CountryCode["CD"] = "CD";
    CountryCode["CG"] = "CG";
    CountryCode["CK"] = "CK";
    CountryCode["CR"] = "CR";
    CountryCode["CI"] = "CI";
    CountryCode["HR"] = "HR";
    CountryCode["CU"] = "CU";
    CountryCode["CW"] = "CW";
    CountryCode["CY"] = "CY";
    CountryCode["CZ"] = "CZ";
    CountryCode["DK"] = "DK";
    CountryCode["DJ"] = "DJ";
    CountryCode["DM"] = "DM";
    CountryCode["DO"] = "DO";
    CountryCode["EC"] = "EC";
    CountryCode["EG"] = "EG";
    CountryCode["SV"] = "SV";
    CountryCode["GQ"] = "GQ";
    CountryCode["ER"] = "ER";
    CountryCode["EE"] = "EE";
    CountryCode["SZ"] = "SZ";
    CountryCode["ET"] = "ET";
    CountryCode["FK"] = "FK";
    CountryCode["FO"] = "FO";
    CountryCode["FJ"] = "FJ";
    CountryCode["FI"] = "FI";
    CountryCode["FR"] = "FR";
    CountryCode["GF"] = "GF";
    CountryCode["PF"] = "PF";
    CountryCode["TF"] = "TF";
    CountryCode["GA"] = "GA";
    CountryCode["GM"] = "GM";
    CountryCode["GE"] = "GE";
    CountryCode["DE"] = "DE";
    CountryCode["GH"] = "GH";
    CountryCode["GI"] = "GI";
    CountryCode["GR"] = "GR";
    CountryCode["GL"] = "GL";
    CountryCode["GD"] = "GD";
    CountryCode["GP"] = "GP";
    CountryCode["GU"] = "GU";
    CountryCode["GT"] = "GT";
    CountryCode["GG"] = "GG";
    CountryCode["GN"] = "GN";
    CountryCode["GW"] = "GW";
    CountryCode["GY"] = "GY";
    CountryCode["HT"] = "HT";
    CountryCode["HM"] = "HM";
    CountryCode["VA"] = "VA";
    CountryCode["HN"] = "HN";
    CountryCode["HK"] = "HK";
    CountryCode["HU"] = "HU";
    CountryCode["IS"] = "IS";
    CountryCode["IN"] = "IN";
    CountryCode["ID"] = "ID";
    CountryCode["IR"] = "IR";
    CountryCode["IQ"] = "IQ";
    CountryCode["IE"] = "IE";
    CountryCode["IM"] = "IM";
    CountryCode["IL"] = "IL";
    CountryCode["IT"] = "IT";
    CountryCode["JM"] = "JM";
    CountryCode["JP"] = "JP";
    CountryCode["JE"] = "JE";
    CountryCode["JO"] = "JO";
    CountryCode["KZ"] = "KZ";
    CountryCode["KE"] = "KE";
    CountryCode["KI"] = "KI";
    CountryCode["KP"] = "KP";
    CountryCode["KR"] = "KR";
    CountryCode["KW"] = "KW";
    CountryCode["KG"] = "KG";
    CountryCode["LA"] = "LA";
    CountryCode["LV"] = "LV";
    CountryCode["LB"] = "LB";
    CountryCode["LS"] = "LS";
    CountryCode["LR"] = "LR";
    CountryCode["LY"] = "LY";
    CountryCode["LI"] = "LI";
    CountryCode["LT"] = "LT";
    CountryCode["LU"] = "LU";
    CountryCode["MO"] = "MO";
    CountryCode["MG"] = "MG";
    CountryCode["MW"] = "MW";
    CountryCode["MY"] = "MY";
    CountryCode["MV"] = "MV";
    CountryCode["ML"] = "ML";
    CountryCode["MT"] = "MT";
    CountryCode["MH"] = "MH";
    CountryCode["MQ"] = "MQ";
    CountryCode["MR"] = "MR";
    CountryCode["MU"] = "MU";
    CountryCode["YT"] = "YT";
    CountryCode["MX"] = "MX";
    CountryCode["FM"] = "FM";
    CountryCode["MD"] = "MD";
    CountryCode["MC"] = "MC";
    CountryCode["MN"] = "MN";
    CountryCode["ME"] = "ME";
    CountryCode["MS"] = "MS";
    CountryCode["MA"] = "MA";
    CountryCode["MZ"] = "MZ";
    CountryCode["MM"] = "MM";
    CountryCode["NA"] = "NA";
    CountryCode["NR"] = "NR";
    CountryCode["NP"] = "NP";
    CountryCode["NL"] = "NL";
    CountryCode["NC"] = "NC";
    CountryCode["NZ"] = "NZ";
    CountryCode["NI"] = "NI";
    CountryCode["NE"] = "NE";
    CountryCode["NG"] = "NG";
    CountryCode["NU"] = "NU";
    CountryCode["NF"] = "NF";
    CountryCode["MK"] = "MK";
    CountryCode["MP"] = "MP";
    CountryCode["NO"] = "NO";
    CountryCode["OM"] = "OM";
    CountryCode["PK"] = "PK";
    CountryCode["PW"] = "PW";
    CountryCode["PS"] = "PS";
    CountryCode["PA"] = "PA";
    CountryCode["PG"] = "PG";
    CountryCode["PY"] = "PY";
    CountryCode["PE"] = "PE";
    CountryCode["PH"] = "PH";
    CountryCode["PN"] = "PN";
    CountryCode["PL"] = "PL";
    CountryCode["PT"] = "PT";
    CountryCode["PR"] = "PR";
    CountryCode["QA"] = "QA";
    CountryCode["RE"] = "RE";
    CountryCode["RO"] = "RO";
    CountryCode["RU"] = "RU";
    CountryCode["RW"] = "RW";
    CountryCode["BL"] = "BL";
    CountryCode["SH"] = "SH";
    CountryCode["KN"] = "KN";
    CountryCode["LC"] = "LC";
    CountryCode["MF"] = "MF";
    CountryCode["PM"] = "PM";
    CountryCode["VC"] = "VC";
    CountryCode["WS"] = "WS";
    CountryCode["SM"] = "SM";
    CountryCode["ST"] = "ST";
    CountryCode["SA"] = "SA";
    CountryCode["SN"] = "SN";
    CountryCode["RS"] = "RS";
    CountryCode["SC"] = "SC";
    CountryCode["SL"] = "SL";
    CountryCode["SG"] = "SG";
    CountryCode["SX"] = "SX";
    CountryCode["SK"] = "SK";
    CountryCode["SI"] = "SI";
    CountryCode["SB"] = "SB";
    CountryCode["SO"] = "SO";
    CountryCode["ZA"] = "ZA";
    CountryCode["GS"] = "GS";
    CountryCode["SS"] = "SS";
    CountryCode["ES"] = "ES";
    CountryCode["LK"] = "LK";
    CountryCode["SD"] = "SD";
    CountryCode["SR"] = "SR";
    CountryCode["SJ"] = "SJ";
    CountryCode["SE"] = "SE";
    CountryCode["CH"] = "CH";
    CountryCode["SY"] = "SY";
    CountryCode["TW"] = "TW";
    CountryCode["TJ"] = "TJ";
    CountryCode["TZ"] = "TZ";
    CountryCode["TH"] = "TH";
    CountryCode["TL"] = "TL";
    CountryCode["TG"] = "TG";
    CountryCode["TK"] = "TK";
    CountryCode["TO"] = "TO";
    CountryCode["TT"] = "TT";
    CountryCode["TN"] = "TN";
    CountryCode["TR"] = "TR";
    CountryCode["TM"] = "TM";
    CountryCode["TC"] = "TC";
    CountryCode["TV"] = "TV";
    CountryCode["UG"] = "UG";
    CountryCode["UA"] = "UA";
    CountryCode["AE"] = "AE";
    CountryCode["GB"] = "GB";
    CountryCode["US"] = "US";
    CountryCode["UM"] = "UM";
    CountryCode["UY"] = "UY";
    CountryCode["UZ"] = "UZ";
    CountryCode["VU"] = "VU";
    CountryCode["VE"] = "VE";
    CountryCode["VN"] = "VN";
    CountryCode["VG"] = "VG";
    CountryCode["VI"] = "VI";
    CountryCode["WF"] = "WF";
    CountryCode["EH"] = "EH";
    CountryCode["YE"] = "YE";
    CountryCode["ZM"] = "ZM";
    CountryCode["ZW"] = "ZW";
})(CountryCode || (CountryCode = {}));
/**
 * ISO 3166-1 country names mapped by their alpha-2 codes.
 */
export const COUNTRY_NAMES = {
    [CountryCode.AF]: 'Afghanistan',
    [CountryCode.AX]: 'Åland Islands',
    [CountryCode.AL]: 'Albania',
    [CountryCode.DZ]: 'Algeria',
    [CountryCode.AS]: 'American Samoa',
    [CountryCode.AD]: 'Andorra',
    [CountryCode.AO]: 'Angola',
    [CountryCode.AI]: 'Anguilla',
    [CountryCode.AQ]: 'Antarctica',
    [CountryCode.AG]: 'Antigua and Barbuda',
    [CountryCode.AR]: 'Argentina',
    [CountryCode.AM]: 'Armenia',
    [CountryCode.AW]: 'Aruba',
    [CountryCode.AU]: 'Australia',
    [CountryCode.AT]: 'Austria',
    [CountryCode.AZ]: 'Azerbaijan',
    [CountryCode.BS]: 'Bahamas',
    [CountryCode.BH]: 'Bahrain',
    [CountryCode.BD]: 'Bangladesh',
    [CountryCode.BB]: 'Barbados',
    [CountryCode.BY]: 'Belarus',
    [CountryCode.BE]: 'Belgium',
    [CountryCode.BZ]: 'Belize',
    [CountryCode.BJ]: 'Benin',
    [CountryCode.BM]: 'Bermuda',
    [CountryCode.BT]: 'Bhutan',
    [CountryCode.BO]: 'Bolivia',
    [CountryCode.BQ]: 'Bonaire, Sint Eustatius and Saba',
    [CountryCode.BA]: 'Bosnia and Herzegovina',
    [CountryCode.BW]: 'Botswana',
    [CountryCode.BV]: 'Bouvet Island',
    [CountryCode.BR]: 'Brazil',
    [CountryCode.IO]: 'British Indian Ocean Territory',
    [CountryCode.BN]: 'Brunei Darussalam',
    [CountryCode.BG]: 'Bulgaria',
    [CountryCode.BF]: 'Burkina Faso',
    [CountryCode.BI]: 'Burundi',
    [CountryCode.KH]: 'Cambodia',
    [CountryCode.CM]: 'Cameroon',
    [CountryCode.CA]: 'Canada',
    [CountryCode.CV]: 'Cabo Verde',
    [CountryCode.KY]: 'Cayman Islands',
    [CountryCode.CF]: 'Central African Republic',
    [CountryCode.TD]: 'Chad',
    [CountryCode.CL]: 'Chile',
    [CountryCode.CN]: 'China',
    [CountryCode.CX]: 'Christmas Island',
    [CountryCode.CC]: 'Cocos (Keeling) Islands',
    [CountryCode.CO]: 'Colombia',
    [CountryCode.KM]: 'Comoros',
    [CountryCode.CD]: 'Congo, Democratic Republic of the',
    [CountryCode.CG]: 'Congo',
    [CountryCode.CK]: 'Cook Islands',
    [CountryCode.CR]: 'Costa Rica',
    [CountryCode.CI]: "Côte d'Ivoire",
    [CountryCode.HR]: 'Croatia',
    [CountryCode.CU]: 'Cuba',
    [CountryCode.CW]: 'Curaçao',
    [CountryCode.CY]: 'Cyprus',
    [CountryCode.CZ]: 'Czechia',
    [CountryCode.DK]: 'Denmark',
    [CountryCode.DJ]: 'Djibouti',
    [CountryCode.DM]: 'Dominica',
    [CountryCode.DO]: 'Dominican Republic',
    [CountryCode.EC]: 'Ecuador',
    [CountryCode.EG]: 'Egypt',
    [CountryCode.SV]: 'El Salvador',
    [CountryCode.GQ]: 'Equatorial Guinea',
    [CountryCode.ER]: 'Eritrea',
    [CountryCode.EE]: 'Estonia',
    [CountryCode.SZ]: 'Eswatini',
    [CountryCode.ET]: 'Ethiopia',
    [CountryCode.FK]: 'Falkland Islands (Malvinas)',
    [CountryCode.FO]: 'Faroe Islands',
    [CountryCode.FJ]: 'Fiji',
    [CountryCode.FI]: 'Finland',
    [CountryCode.FR]: 'France',
    [CountryCode.GF]: 'French Guiana',
    [CountryCode.PF]: 'French Polynesia',
    [CountryCode.TF]: 'French Southern Territories',
    [CountryCode.GA]: 'Gabon',
    [CountryCode.GM]: 'Gambia',
    [CountryCode.GE]: 'Georgia',
    [CountryCode.DE]: 'Germany',
    [CountryCode.GH]: 'Ghana',
    [CountryCode.GI]: 'Gibraltar',
    [CountryCode.GR]: 'Greece',
    [CountryCode.GL]: 'Greenland',
    [CountryCode.GD]: 'Grenada',
    [CountryCode.GP]: 'Guadeloupe',
    [CountryCode.GU]: 'Guam',
    [CountryCode.GT]: 'Guatemala',
    [CountryCode.GG]: 'Guernsey',
    [CountryCode.GN]: 'Guinea',
    [CountryCode.GW]: 'Guinea-Bissau',
    [CountryCode.GY]: 'Guyana',
    [CountryCode.HT]: 'Haiti',
    [CountryCode.HM]: 'Heard Island and McDonald Islands',
    [CountryCode.VA]: 'Holy See',
    [CountryCode.HN]: 'Honduras',
    [CountryCode.HK]: 'Hong Kong',
    [CountryCode.HU]: 'Hungary',
    [CountryCode.IS]: 'Iceland',
    [CountryCode.IN]: 'India',
    [CountryCode.ID]: 'Indonesia',
    [CountryCode.IR]: 'Iran',
    [CountryCode.IQ]: 'Iraq',
    [CountryCode.IE]: 'Ireland',
    [CountryCode.IM]: 'Isle of Man',
    [CountryCode.IL]: 'Israel',
    [CountryCode.IT]: 'Italy',
    [CountryCode.JM]: 'Jamaica',
    [CountryCode.JP]: 'Japan',
    [CountryCode.JE]: 'Jersey',
    [CountryCode.JO]: 'Jordan',
    [CountryCode.KZ]: 'Kazakhstan',
    [CountryCode.KE]: 'Kenya',
    [CountryCode.KI]: 'Kiribati',
    [CountryCode.KP]: "Korea, Democratic People's Republic of",
    [CountryCode.KR]: 'Korea, Republic of',
    [CountryCode.KW]: 'Kuwait',
    [CountryCode.KG]: 'Kyrgyzstan',
    [CountryCode.LA]: "Lao People's Democratic Republic",
    [CountryCode.LV]: 'Latvia',
    [CountryCode.LB]: 'Lebanon',
    [CountryCode.LS]: 'Lesotho',
    [CountryCode.LR]: 'Liberia',
    [CountryCode.LY]: 'Libya',
    [CountryCode.LI]: 'Liechtenstein',
    [CountryCode.LT]: 'Lithuania',
    [CountryCode.LU]: 'Luxembourg',
    [CountryCode.MO]: 'Macao',
    [CountryCode.MG]: 'Madagascar',
    [CountryCode.MW]: 'Malawi',
    [CountryCode.MY]: 'Malaysia',
    [CountryCode.MV]: 'Maldives',
    [CountryCode.ML]: 'Mali',
    [CountryCode.MT]: 'Malta',
    [CountryCode.MH]: 'Marshall Islands',
    [CountryCode.MQ]: 'Martinique',
    [CountryCode.MR]: 'Mauritania',
    [CountryCode.MU]: 'Mauritius',
    [CountryCode.YT]: 'Mayotte',
    [CountryCode.MX]: 'Mexico',
    [CountryCode.FM]: 'Micronesia',
    [CountryCode.MD]: 'Moldova',
    [CountryCode.MC]: 'Monaco',
    [CountryCode.MN]: 'Mongolia',
    [CountryCode.ME]: 'Montenegro',
    [CountryCode.MS]: 'Montserrat',
    [CountryCode.MA]: 'Morocco',
    [CountryCode.MZ]: 'Mozambique',
    [CountryCode.MM]: 'Myanmar',
    [CountryCode.NA]: 'Namibia',
    [CountryCode.NR]: 'Nauru',
    [CountryCode.NP]: 'Nepal',
    [CountryCode.NL]: 'Netherlands',
    [CountryCode.NC]: 'New Caledonia',
    [CountryCode.NZ]: 'New Zealand',
    [CountryCode.NI]: 'Nicaragua',
    [CountryCode.NE]: 'Niger',
    [CountryCode.NG]: 'Nigeria',
    [CountryCode.NU]: 'Niue',
    [CountryCode.NF]: 'Norfolk Island',
    [CountryCode.MK]: 'North Macedonia',
    [CountryCode.MP]: 'Northern Mariana Islands',
    [CountryCode.NO]: 'Norway',
    [CountryCode.OM]: 'Oman',
    [CountryCode.PK]: 'Pakistan',
    [CountryCode.PW]: 'Palau',
    [CountryCode.PS]: 'Palestine, State of',
    [CountryCode.PA]: 'Panama',
    [CountryCode.PG]: 'Papua New Guinea',
    [CountryCode.PY]: 'Paraguay',
    [CountryCode.PE]: 'Peru',
    [CountryCode.PH]: 'Philippines',
    [CountryCode.PN]: 'Pitcairn',
    [CountryCode.PL]: 'Poland',
    [CountryCode.PT]: 'Portugal',
    [CountryCode.PR]: 'Puerto Rico',
    [CountryCode.QA]: 'Qatar',
    [CountryCode.RE]: 'Réunion',
    [CountryCode.RO]: 'Romania',
    [CountryCode.RU]: 'Russian Federation',
    [CountryCode.RW]: 'Rwanda',
    [CountryCode.BL]: 'Saint Barthélemy',
    [CountryCode.SH]: 'Saint Helena, Ascension and Tristan da Cunha',
    [CountryCode.KN]: 'Saint Kitts and Nevis',
    [CountryCode.LC]: 'Saint Lucia',
    [CountryCode.MF]: 'Saint Martin (French part)',
    [CountryCode.PM]: 'Saint Pierre and Miquelon',
    [CountryCode.VC]: 'Saint Vincent and the Grenadines',
    [CountryCode.WS]: 'Samoa',
    [CountryCode.SM]: 'San Marino',
    [CountryCode.ST]: 'Sao Tome and Principe',
    [CountryCode.SA]: 'Saudi Arabia',
    [CountryCode.SN]: 'Senegal',
    [CountryCode.RS]: 'Serbia',
    [CountryCode.SC]: 'Seychelles',
    [CountryCode.SL]: 'Sierra Leone',
    [CountryCode.SG]: 'Singapore',
    [CountryCode.SX]: 'Sint Maarten (Dutch part)',
    [CountryCode.SK]: 'Slovakia',
    [CountryCode.SI]: 'Slovenia',
    [CountryCode.SB]: 'Solomon Islands',
    [CountryCode.SO]: 'Somalia',
    [CountryCode.ZA]: 'South Africa',
    [CountryCode.GS]: 'South Georgia and the South Sandwich Islands',
    [CountryCode.SS]: 'South Sudan',
    [CountryCode.ES]: 'Spain',
    [CountryCode.LK]: 'Sri Lanka',
    [CountryCode.SD]: 'Sudan',
    [CountryCode.SR]: 'Suriname',
    [CountryCode.SJ]: 'Svalbard and Jan Mayen',
    [CountryCode.SE]: 'Sweden',
    [CountryCode.CH]: 'Switzerland',
    [CountryCode.SY]: 'Syrian Arab Republic',
    [CountryCode.TW]: 'Taiwan',
    [CountryCode.TJ]: 'Tajikistan',
    [CountryCode.TZ]: 'Tanzania',
    [CountryCode.TH]: 'Thailand',
    [CountryCode.TL]: 'Timor-Leste',
    [CountryCode.TG]: 'Togo',
    [CountryCode.TK]: 'Tokelau',
    [CountryCode.TO]: 'Tonga',
    [CountryCode.TT]: 'Trinidad and Tobago',
    [CountryCode.TN]: 'Tunisia',
    [CountryCode.TR]: 'Türkiye',
    [CountryCode.TM]: 'Turkmenistan',
    [CountryCode.TC]: 'Turks and Caicos Islands',
    [CountryCode.TV]: 'Tuvalu',
    [CountryCode.UG]: 'Uganda',
    [CountryCode.UA]: 'Ukraine',
    [CountryCode.AE]: 'United Arab Emirates',
    [CountryCode.GB]: 'United Kingdom',
    [CountryCode.US]: 'United States',
    [CountryCode.UM]: 'United States Minor Outlying Islands',
    [CountryCode.UY]: 'Uruguay',
    [CountryCode.UZ]: 'Uzbekistan',
    [CountryCode.VU]: 'Vanuatu',
    [CountryCode.VE]: 'Venezuela',
    [CountryCode.VN]: 'Viet Nam',
    [CountryCode.VG]: 'Virgin Islands (British)',
    [CountryCode.VI]: 'Virgin Islands (U.S.)',
    [CountryCode.WF]: 'Wallis and Futuna',
    [CountryCode.EH]: 'Western Sahara',
    [CountryCode.YE]: 'Yemen',
    [CountryCode.ZM]: 'Zambia',
    [CountryCode.ZW]: 'Zimbabwe',
};
/**
 * Zod schema for validating country codes.
 */
export const CountryCodeSchema = z.enum(CountryCode);
/**
 * Helper to fetch all supported country codes.
 */
export function getAllCountryCodes() {
    return Object.values(CountryCode);
}
/**
 * Validate whether an unknown value is a supported country code.
 */
export function isValidCountryCode(value) {
    return typeof value === 'string' && Object.values(CountryCode).includes(value);
}
/**
 * Get the full country name for a country code.
 * @param code - ISO 3166-1 alpha-2 country code
 * @returns Full country name, or the code itself if not found
 */
export function getCountryName(code) {
    return COUNTRY_NAMES[code] ?? code;
}
/**
 * Returns all country codes as choice objects suitable for form dropdowns.
 * @param format - 'code' for "GB", 'name' for "United Kingdom" (default: 'code')
 * @returns Array of objects with value and text properties
 */
export function getCountryCodeChoices(format = 'code') {
    return Object.values(CountryCode).map((code) => ({
        value: code,
        text: format === 'name' ? getCountryName(code) : code,
    }));
}
//# sourceMappingURL=CountryCode.js.map